import { ajaxCatch, AjaxCatchExtraActions } from 'rxOperators/ajaxCatch'
import { Epic, EpicRefined } from 'interfaces/middleware'
import { mergeMap, map } from 'rxjs/operators'
import {
  CCOnboardingAcceptAction,
  CCOnboardingActions,
  CCOnboardingInitiateAction,
  GetCCOnboardingStateAction,
  JoinCCWaitlistAction,
} from 'components/features/creditCard/creditCardStore/actions'
import { of, merge } from 'rxjs'
import { filterRequest } from 'rxOperators/filterRequestOfType'
import { CC_ONBOARDING_ACCEPT_OFFER_URL, CC_ONBOARDING_INITIATE_URL, CC_ONBOARDING_URL, CC_JOIN_WAITLIST_URL } from 'components/features/creditCard/creditCardStore/endpoints'
import { pushActionCreator } from 'actions/navigationActions'

export const joinWaitlistEpic: Epic = (action$, _, { post }) => action$.pipe(
  filterRequest(JoinCCWaitlistAction.type),
  mergeMap((action) => post(CC_JOIN_WAITLIST_URL, { body: {}}).pipe(
    mergeMap(() => merge(
      of(action.success()),
    )),
    ajaxCatch((error) => of(action.fail({ errorCode: error.status, errorsMap: error.response }))),
  )),
)

export const getCCOnboardingEpic: EpicRefined<CCOnboardingActions | AjaxCatchExtraActions> = (action$, _store, { get }) => action$.pipe(
  filterRequest(GetCCOnboardingStateAction.type),
  mergeMap((action) => {
    return get(CC_ONBOARDING_URL).pipe(
      map(({ response }) => action.success(response)),
      ajaxCatch((error) => of(action.fail({ errorCode: error.status })))
    )
  }),
)

export const ccOnboardingInitiateEpic: Epic = (action$, _, { post }) => action$.pipe(
  filterRequest(CCOnboardingInitiateAction.type),
  mergeMap((action) => post(CC_ONBOARDING_INITIATE_URL, {
    body: {
      socure_session_id: action.payload.params,
    },
  }).pipe(
    mergeMap(({ response }) => merge(
      of(action.success(response)),
      of(pushActionCreator('/credit-card/onboarding/pending')),
    )),
    ajaxCatch((error) => of(action.fail({ errorCode: error.status, errorsMap: error.response }))),
  )),
)

export const ccOnboardingAcceptEpic: Epic = (action$, _, { post }) => action$.pipe(
  filterRequest(CCOnboardingAcceptAction.type),
  mergeMap((action) => post(CC_ONBOARDING_ACCEPT_OFFER_URL, { body: {}}).pipe(
    mergeMap(({ response }) => merge(
      of(action.success(response)),
      of(pushActionCreator('/credit-card/onboarding/submit')),
    )),
    ajaxCatch((error) => of(action.fail({ errorCode: error.status, errorsMap: error.response }))),
  )),
)
